import { createSlice } from "@reduxjs/toolkit";

const filterSlice = createSlice({
  name: 'filter',
  initialState: {
    value: 'SEVEN_DAYS',
    mode: 'relative',
    customStartDate: null,
    customEndDate: null,
  },
  reducers: {
    updateFilter: (state, action) => {
      state.value = action.payload;
      state.mode = 'relative';
    },
    setFilterMode: (state, action) => {
      state.mode = action.payload;
    },
    updateCustomDateRange: (state, action) => {
      const { startDate, endDate } = action.payload || {};
      state.customStartDate = startDate || null;
      state.customEndDate = endDate || null;

      if (startDate && endDate)
        state.mode = 'custom';
    },
  },
});

export const { updateFilter, setFilterMode, updateCustomDateRange } = filterSlice.actions;
export default filterSlice.reducer;
